const sanitizeFileName = (fileName) => {
  const sanitizedFileName = fileName.replace(/\s/g, '_').toLowerCase();

  return sanitizedFileName;
};

export default sanitizeFileName;
